(function () {
  'use strict';

  /* --- Media gating: swap the product photo only after ALL options chosen. --- */
  function patchMedia() {
    var VS = window.customElements && customElements.get('variant-selects');
    if (!VS || !VS.prototype || VS.prototype.__fitmentMediaPatched) return;
    var original = VS.prototype.updateMedia;
    if (typeof original !== 'function') return;
    VS.prototype.updateMedia = function () {
      var stepper = this.closest('fitment-stepper');
      // Suppress the gallery swap while the vehicle is still being chosen (editing).
      // The variant model auto-fills options, so we gate on "confirmed", not on
      // raw completeness, to match "change image only after confirming the vehicle".
      if (stepper && typeof stepper.isConfirmed === 'function' && !stepper.isConfirmed()) {
        return;
      }
      // Confirmed: a per-variant image (e.g. Body Style Sedan vs Coupe) may not be in
      // the current gallery DOM at all — with the theme's "only show variant images"
      // mode the gallery is server-rendered with just the ACTIVE variant's media, so
      // the native setActiveMedia has nothing to switch to (and throws on the missing
      // element). Re-render the gallery server-side for the active variant instead.
      if (stepper && typeof stepper.refreshVariantMedia === 'function') {
        stepper.refreshVariantMedia();
        return;
      }
      return original.apply(this, arguments);
    };
    VS.prototype.__fitmentMediaPatched = true;
  }
  patchMedia();
  document.addEventListener('DOMContentLoaded', patchMedia);

  // Persist UI state across full section re-renders (the theme may replace the
  // whole element on a variant change). Keyed by section id, lives for the page.
  var FITMENT_STATE = {};

  class FitmentStepper extends HTMLElement {
    constructor() {
      super();
      this.forceEdit = true;
      this.openStep = 0;
      this.autoYearApplied = false;
      this.pendingAdvanceFromYear = false;
      this._onClick = this._onClick.bind(this);
      this._onSubmitCapture = this._onSubmitCapture.bind(this);
      this._onVariantChange = this._onVariantChange.bind(this);
    }

    connectedCallback() {
      this.sectionId = this.dataset.section;
      var saved = FITMENT_STATE[this.sectionId];
      if (saved) {
        this.forceEdit = saved.forceEdit;
        this.openStep = saved.openStep;
        this.autoYearApplied = saved.autoYearApplied;
      } else {
        this.forceEdit = !this.classList.contains('fitment-stepper--confirmed');
        this.openStep = this.forceEdit ? 0 : null;
        this.autoYearApplied = false;
      }
      this.addEventListener('click', this._onClick);
      document.addEventListener('submit', this._onSubmitCapture, true);
      document.addEventListener('product:variant-change', this._onVariantChange);
      this._tryAutoYear();
      this.applyState();
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this._onSubmitCapture, true);
      document.removeEventListener('product:variant-change', this._onVariantChange);
    }

    _save() {
      FITMENT_STATE[this.sectionId] = {
        forceEdit: this.forceEdit,
        openStep: this.openStep,
        autoYearApplied: this.autoYearApplied
      };
    }

    /* --- #2: variant image swap via a server re-render of the media gallery. --- */
    // The theme's "only show variant images" gallery is server-rendered with ONLY the
    // active variant's media (product-media-gallery.liquid skips other variants' images
    // when section.settings.hide_variants is on). So a per-variant image (Body Style
    // Sedan vs Coupe) is NOT in the gallery DOM, and the native setActiveMedia can't
    // switch to it (it throws on the missing element). Re-fetch the section for the
    // selected variant and swap in the freshly-rendered gallery, which the server
    // renders with that variant's image active. Verified live on the Honda Civic PDP.
    refreshVariantMedia() {
      var vs = this.querySelector('variant-selects');
      if (!vs) return;
      var section = vs.dataset.section || this.sectionId;
      var baseUrl = vs.dataset.url;
      var idInput = this.form ? this.form.querySelector('[name="id"]') : null;
      var variantId =
        (vs.currentVariant && vs.currentVariant.id) || (idInput && idInput.value);
      if (!baseUrl || !variantId) return;
      // Dedupe: skip when we already rendered this exact variant's gallery.
      if (this._mediaVariantId === String(variantId)) return;
      this._mediaVariantId = String(variantId);
      var url =
        baseUrl +
        (baseUrl.indexOf('?') > -1 ? '&' : '?') +
        'variant=' + encodeURIComponent(variantId) +
        '&section_id=' + encodeURIComponent(section);
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('media-gallery');
          var live =
            document.getElementById('MediaGallery-' + section) ||
            document.querySelector('media-gallery');
          if (!fresh || !live) return;
          // Replace only when the active image actually differs (no flash otherwise).
          var fa = fresh.querySelector('.product-media-main.is-active[data-media-id]');
          var la = live.querySelector('.product-media-main.is-active[data-media-id]');
          var fid = fa && fa.getAttribute('data-media-id');
          var lid = la && la.getAttribute('data-media-id');
          if (fid && fid !== lid) live.replaceWith(fresh);
        })
        .catch(function () {});
    }

    // Client #1: while editing, force the gallery back to the product's DEFAULT image
    // (data-default-media = product.featured_media). The default is a non-variant media,
    // always present in the gallery DOM, so setActiveMedia can't miss it. Cheap + guarded:
    // no-op when it's already active. Clears the media-variant cache so a later confirm
    // re-swaps to the variant image.
    _showDefaultMedia() {
      var vs = this.querySelector('variant-selects');
      var section = (vs && vs.dataset.section) || this.sectionId;
      var defId = this.dataset.defaultMedia;
      var mg = document.getElementById('MediaGallery-' + section);
      if (!defId || !mg || typeof mg.setActiveMedia !== 'function') return;
      var active = mg.querySelector('.product-media-main.is-active[data-media-id]');
      if (active && active.getAttribute('data-media-id') === String(defId)) return;
      if (!mg.querySelector('.product-media-main[data-media-id="' + defId + '"]')) return;
      try { mg.setActiveMedia(defId, mg.getAttribute('hide-variants') === 'true'); } catch (e) {}
      this._mediaVariantId = null;
    }

    /* --- accessors (re-query: innerHTML is replaced on each variant change) --- */
    get accordions() { return Array.prototype.slice.call(this.querySelectorAll('.fitment-accordion')); }
    get vehicleSelects() { return Array.prototype.slice.call(this.querySelectorAll('.fitment-accordion select')); }
    get styleFieldsets() { return Array.prototype.slice.call(this.querySelectorAll('.fitment-block--style fieldset')); }
    get yearSelect() { return this.querySelector('select[data-fitment-year]'); }
    get form() { return document.getElementById('product-form-' + this.sectionId); }
    get productForm() { var f = this.form; return f ? f.closest('product-form') : null; }
    get titleTexts() {
      // Both product titles carry .product-title-text: the primary title block
      // (sections/main-product.liquid) and the secondary title rendered inside the
      // "Product Information" details block — snippets/main-product-details.liquid
      // wraps product.title with this same hook. So target the class directly
      // instead of matching heading text.
      var sec = document.getElementById('shopify-section-' + this.sectionId) || document;
      return Array.prototype.slice.call(sec.querySelectorAll('.product-title-text'));
    }

    _accordionComplete(acc) {
      var sel = acc.querySelector('select');
      if (sel) return !!(sel.value && sel.value.trim() !== '');
      return !!acc.querySelector('input:checked');
    }

    isVehicleComplete() {
      // every() is true when there are no step accordions (all vehicle options are single-value/fixed).
      return this.accordions.every(this._accordionComplete.bind(this));
    }
    isStyleComplete() {
      // A style option is either a buttons fieldset (radios) or a dropdown fieldset (a <select>).
      return this.styleFieldsets.every(function (fs) {
        var sel = fs.querySelector('select');
        if (sel) return !!(sel.value && sel.value.trim() !== '');
        return !!fs.querySelector('input:checked');
      });
    }
    isFullySelected() { return this.isVehicleComplete() && this.isStyleComplete(); }
    isConfirmed() { return this.isVehicleComplete() && !this.forceEdit; }

    _firstIncompleteStep() {
      var acc = this.accordions;
      for (var i = 0; i < acc.length; i++) {
        if (!this._accordionComplete(acc[i])) return i;
      }
      return 0;
    }

    _indexOfYear() {
      var acc = this.accordions;
      for (var i = 0; i < acc.length; i++) {
        if (acc[i].querySelector('select[data-fitment-year]')) return i;
      }
      return 0;
    }

    applyState() {
      var vehicleComplete = this.isVehicleComplete();
      var confirmed = vehicleComplete && !this.forceEdit;

      this.classList.toggle('fitment-stepper--confirmed', confirmed);
      this.classList.toggle('fitment-stepper--editing', !confirmed);

      // #2 + client #1: the main image swaps to the selected variant's image ONLY
      // once the vehicle is confirmed. While the customer is still choosing (editing),
      // the gallery must show the product's DEFAULT image — not a pre-selected
      // variant's image that the server may have rendered active on load. So: confirmed
      // -> refresh to the variant image; editing -> reset to the default product image.
      if (confirmed) this.refreshVariantMedia();
      else this._showDefaultMedia();

      // #1: while the vehicle is being edited, hide the price/buy area (CSS targets
      // this section-level class). Quantity + the locked "Add to cart" stay visible.
      var sec = document.getElementById('shopify-section-' + this.sectionId);
      if (sec) sec.classList.toggle('fitment-section-editing', !confirmed);

      var self = this;
      var openIndex = (this.openStep != null) ? this.openStep : 0;
      this.accordions.forEach(function (acc, i) {
        var open = (i === openIndex);
        acc.classList.toggle('is-open', open);
        var head = acc.querySelector('.fitment-accordion-head');
        var body = acc.querySelector('.fitment-accordion-body');
        if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (body) body.hidden = !open;
        // #1: gate this step's Continue — disabled + semi-transparent until it has a value.
        var cont = acc.querySelector('.fitment-continue');
        if (cont) {
          var incomplete = !self._accordionComplete(acc);
          cont.classList.toggle('fitment-continue--disabled', incomplete);
          cont.setAttribute('aria-disabled', incomplete ? 'true' : 'false');
        }
      });

      var pf = this.productForm;
      if (pf) {
        pf.classList.remove('visually-hidden');
        var locked = !(confirmed && this.isFullySelected());
        pf.classList.toggle('fitment-locked', locked);
        var addBtn = pf.querySelector('[name="add"]');
        if (addBtn) addBtn.setAttribute('aria-disabled', locked ? 'true' : 'false');
      }

      this._applyTitlePrefix(vehicleComplete);
      this._save();

      if (this.pendingAdvanceFromYear && this.yearSelect && this.yearSelect.value) {
        this.pendingAdvanceFromYear = false;
        this._advanceFrom(this._indexOfYear());
      }
    }

    // Linear: Continue opens the NEXT accordion, or confirms after the last one.
    // (The variant model auto-fills later options, so we must not "skip" filled steps.)
    _advanceFrom(index) {
      if (index + 1 < this.accordions.length) {
        this.openStep = index + 1;
        this.forceEdit = true;
      } else {
        this.openStep = null;
        this.forceEdit = false;
      }
      this.applyState();
    }

    _applyTitlePrefix(vehicleComplete) {
      var els = this.titleTexts;
      if (!els.length) return;
      var ys = this.yearSelect;
      var year = (ys && ys.value) ? ys.value.trim() : '';
      var prefix = (year && !this.forceEdit && vehicleComplete);
      els.forEach(function (el) {
        var base = el.dataset.baseTitle || el.textContent.trim();
        el.dataset.baseTitle = base;
        el.textContent = prefix ? (year + ' ' + base) : base;
      });
    }

    _onClick(e) {
      var head = e.target.closest('.fitment-accordion-head');
      if (head && this.contains(head)) {
        this._editStep(this.accordions.indexOf(head.closest('.fitment-accordion')), false);
        return;
      }
      var cont = e.target.closest('.fitment-continue');
      if (cont && this.contains(cont)) {
        e.preventDefault();
        var contAcc = cont.closest('.fitment-accordion');
        // #1: block advancing until this step has an explicit selection.
        if (!this._accordionComplete(contAcc)) return;
        this._advanceFrom(this.accordions.indexOf(contAcc));
        return;
      }
      var edit = e.target.closest('.fitment-edit');
      if (edit && this.contains(edit)) {
        e.preventDefault();
        this._editStep(0, true);
      }
    }

    // Client bug (ticket #108674784): going back to an earlier step must clear every
    // LATER step, so the current step is filtered ONLY by the steps above it — never by
    // a still-applied lower step (which is why e.g. Hatchback was hiding years that have
    // no Hatchback variant). If nothing below is selected the list is already full, so a
    // plain open is enough (no fetch); otherwise we re-render the picker with only the
    // steps up to & including this one applied (see _resetToStep).
    _editStep(index, scroll) {
      if (this._hasSelectionAfter(index)) {
        this._resetToStep(index, scroll);
      } else {
        this.openStep = index;
        this.forceEdit = true;
        this.applyState();
        if (scroll) this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    // Is any step AFTER `index` chosen? (a later vehicle accordion, or any Product Style
    // option). Post-confirm this is always true; mid-wizard the tail is blank -> false.
    _hasSelectionAfter(index) {
      var acc = this.accordions;
      for (var i = index + 1; i < acc.length; i++) {
        if (this._accordionComplete(acc[i])) return true;
      }
      return this.styleFieldsets.some(function (fs) {
        var sel = fs.querySelector('select');
        if (sel) return !!(sel.value && sel.value.trim() !== '');
        return !!fs.querySelector('input:checked');
      });
    }

    // Re-render the picker from a clean slate. We fetch the section with NO variant/option
    // params, which is the ONLY server state that returns every option list COMPLETE and
    // unfiltered (product.selected_variant is blank -> a leading blank option, no
    // cross-filtering). This is what makes the top step (Year) show every value again
    // instead of only the years that have the still-selected lower option (the client bug).
    //
    // Why not `?option_values=<kept ids>`: Shopify AUTO-COMPLETES a partial option set to a
    // full variant and re-applies the cross-filtering, so it does not reset anything
    // (verified on the sandbox). Instead we blank everything, then replay the steps ABOVE
    // the edited one through the theme's own engine so they cascade normally.
    _resetToStep(index, scroll) {
      var vs = this.querySelector('variant-selects, variant-radios');
      var baseUrl = vs && vs.dataset.url;
      var section = (vs && vs.dataset.section) || this.sectionId;
      this.openStep = index;
      this.forceEdit = true;
      if (!vs || !baseUrl) { this.applyState(); return; }

      // Preserve the steps STRICTLY ABOVE the one being edited (fixed single-value vehicle
      // options are always part of the variant, so they need no replay). Everything from
      // `index` downward is intentionally dropped.
      var preserve = [];
      this.accordions.forEach(function (acc, i) {
        if (i >= index) return;
        var sel = acc.querySelector('select');
        if (sel) { if (sel.value) preserve.push({ type: 'select', name: sel.name, value: sel.value }); return; }
        var radio = acc.querySelector('input:checked');
        if (radio) preserve.push({ type: 'radio', name: radio.name, value: radio.value });
      });

      var url =
        baseUrl +
        (baseUrl.indexOf('?') > -1 ? '&' : '?') +
        'section_id=' + encodeURIComponent(section);

      if (this._resetAbort) this._resetAbort.abort();
      this._resetAbort = new AbortController();
      var self = this;
      fetch(url, { signal: this._resetAbort.signal })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('variant-selects, variant-radios');
          var live = self.querySelector('variant-selects, variant-radios');
          if (!fresh || !live) return;
          live.innerHTML = fresh.innerHTML;
          self._mediaVariantId = null; // force a fresh image swap on the next confirm
          self.applyState();
          if (scroll) self.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Replay the upper steps (only when editing a step below the top) so the current
          // step is re-cascaded by them via the theme's normal change handling.
          if (preserve.length) self._replaySelections(preserve);
        })
        .catch(function () {});
    }

    _replaySelections(preserve) {
      var vs = this.querySelector('variant-selects, variant-radios');
      if (!vs) return;
      var esc = (window.CSS && CSS.escape) ? CSS.escape : function (s) { return s; };
      var changed = null;
      preserve.forEach(function (p) {
        if (p.type === 'select') {
          var sel = vs.querySelector('select[name="' + esc(p.name) + '"]');
          if (sel && Array.prototype.some.call(sel.options, function (o) { return o.value === p.value; })) {
            sel.value = p.value; changed = sel;
          }
        } else {
          var radio = vs.querySelector('input[name="' + esc(p.name) + '"][value="' + esc(p.value) + '"]');
          if (radio) { radio.checked = true; changed = radio; }
        }
      });
      // One change lets the theme resolve the (now upper-only) selection and re-render.
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    }

    _onSubmitCapture(e) {
      var f = this.form;
      if (!f || e.target !== f) return;
      // Source of truth is the controller state, not the (server-re-rendered)
      // lock class — the class can briefly lag a variant-change re-render.
      if (this.isConfirmed() && this.isFullySelected()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.forceEdit = true;
      this.openStep = this._firstIncompleteStep();
      this.applyState();
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    _onVariantChange() {
      // Fired after the theme re-rendered innerHTML/form/title -> re-apply state.
      this.applyState();
    }

    _tryAutoYear() {
      var self = this;
      // The Year is auto-selected ONLY from a real YMM vehicle (easysearch). With no YMM
      // vehicle the Year stays blank so the customer picks it consciously (client request:
      // no "default to newest year").
      var run = function () { self._autoSelectYear(); };
      if (typeof window.easysearch !== 'undefined') run();
      document.addEventListener('easysearch_init_native_search_page', run, { once: true });
      setTimeout(run, 600);
    }

    _autoSelectYear() {
      if (this.autoYearApplied) return;
      var ys = this.yearSelect;
      if (!ys) return;
      var cur = (typeof window.easysearch !== 'undefined' && window.easysearch.curIndex)
        ? String(window.easysearch.curIndex) : '';
      if (!cur) return;
      var m = cur.match(/\b(19|20)\d{2}\b/);
      if (!m) return;
      var year = m[0];
      var match = Array.prototype.slice.call(ys.options).find(function (o) { return o.value.trim() === year; });
      if (!match) { this.autoYearApplied = true; this._save(); return; }
      this.autoYearApplied = true;
      this._save();
      if (ys.value === year) { return; }
      this.pendingAdvanceFromYear = true;
      ys.value = year;
      ys.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('fitment-stepper')) {
    customElements.define('fitment-stepper', FitmentStepper);
  }
})();
